import { FilterShop } from '@shop/frontend/web/js/classes/FilterShop.js';

/**
 *  Класс описывающий реализацию фильтра
 * @extends FilterShop
 */

export default class Filter extends FilterShop {
  constructor() {
    super();
    this.$more = $('#js-more');
    this.$items = $('#js-event-items');
    this.$message = $('#js-events-message');
  }

  setActionMore() {
    this.$more.on('click', () => {
      this.page += 1;
      this.getRequest('append');
    });
  }
}
